/* Zivol Arc — FAQ accordion.
 *
 * Height is animated from 0 to the MEASURED content height, then released to
 * 'auto' once the transition ends, so a long answer can reflow (orientation
 * change, font swap) without being clipped by a stale pixel value.
 *
 * One open at a time: opening a panel closes the others.
 *
 * Under prefers-reduced-motion the panel is set open/closed directly with no
 * transition. The control still works — the animation is what is dropped, not
 * the functionality.
 */
(() => {
  const root = document.querySelector('[data-arc-faq]');
  if (!root) return;

  const items = [...root.querySelectorAll('.arc-faq__item')].map((item) => ({
    btn: item.querySelector('.arc-faq__q'),
    panel: item.querySelector('.arc-faq__a'),
  })).filter((i) => i.btn && i.panel);
  if (!items.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const close = ({ btn, panel }) => {
    btn.setAttribute('aria-expanded', 'false');
    if (reduce.matches) { panel.style.blockSize = '0px'; return; }
    // From auto -> measured px, so the transition has somewhere to travel from.
    panel.style.blockSize = `${panel.scrollHeight}px`;
    requestAnimationFrame(() => { panel.style.blockSize = '0px'; });
  };

  const open = ({ btn, panel }) => {
    btn.setAttribute('aria-expanded', 'true');
    if (reduce.matches) { panel.style.blockSize = 'auto'; return; }
    panel.style.blockSize = `${panel.scrollHeight}px`;
    const done = (e) => {
      if (e.propertyName !== 'block-size' && e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      if (btn.getAttribute('aria-expanded') === 'true') panel.style.blockSize = 'auto';
    };
    panel.addEventListener('transitionend', done);
  };

  items.forEach((it) => {
    it.panel.style.blockSize = '0px';
    it.btn.addEventListener('click', () => {
      const isOpen = it.btn.getAttribute('aria-expanded') === 'true';
      items.forEach((other) => { if (other !== it && other.btn.getAttribute('aria-expanded') === 'true') close(other); });
      isOpen ? close(it) : open(it);
    });
  });
})();
